import type { GetRecurringRevenueResponse } from '@vy/api-definition';
import { GetRecurringRevenueResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { USE_CACHE_HEADER } from '../../services/api/cache-headers';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useGetRecurringRevenue(
  customerId?: string,
  options?: CustomUseQueryOptions<GetRecurringRevenueResponse>,
) {
  return useQuery(
    queryKeys.recurringRevenue(customerId),

    async () => {
      const api = getPrivateApi();
      const getRecurringRevenueResponse = await api.getRecurringRevenue(
        {
          customerId,
        },
        USE_CACHE_HEADER,
      );

      return GetRecurringRevenueResponseSchema.parse(getRecurringRevenueResponse);
    },
    options,
  );
}
